// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"e262aaa4","288":"1bf3b350"}[chunkId] + ".chunk.js";
};